import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";
export const EmprestimoList = (props) => <DefaultDataTable data={props} />;
